<template>
   <!-- begin:: Header -->
   <div>
        <!--begin::Header Mobile-->
        <div id="kt_header_mobile" class="header-mobile" :style="topbarColor">
            <button class="btn p-0 burger-icon burger-icon-left" id="kt_header_mobile_toggle">
              <span></span>
            </button>
            <!--begin::Logo-->
            <router-link to="/shop">
                <img alt="Logo" :src="getBrandImageUrl(brand_logo)" width="200" height="50"/>
            </router-link>
            <!--end::Logo-->
            <!--begin::Toolbar-->
            <div class="d-flex align-items-center">
               <div class="dropdown" v-if="disableCart">
                  <div class="topbar-item mr-3" data-toggle="dropdown" data-offset="0px,10px">
                     <a href="#"  class="btn label-danger  btn-light-danger mr-2">
                        <i class="fas fa-shopping-cart"></i>
                     </a>
                     <span class="label label-md label-danger mr-2 cartLabel">{{formattedCartProductCount}}</span>
                  </div>
                  <cartComponent @productCount="productCountMethod"></cartComponent>
               </div>
              <button class="btn p-0 ml-2" id="kt_header_mobile_topbar_toggle">
              <AccountDetails v-on:brandLogoCatcher="updateBrandLogo($event)"></AccountDetails>
            </button>
            </div>
        <!--end::Toolbar-->
        </div>
          <!--end::Header Mobile-->
          <!--begin::Header-->
        <div class="header header-fixed" id="kt_header" :style="topbarColor">
         <!-- begin:: Brand -->
         <div class="container-fluid">
            <div class="d-none d-lg-flex align-items-center mr-3">
               <router-link to="/shop">
                  <img alt="Logo" :src="getBrandImageUrl(brand_logo)" width="200" height="50"/>
               </router-link>
            </div>
            <div class="topbar topbar-minimize">
               <!--begin: Cart -->
                <template v-if="shouldShowChatIcon && $store.state.brand?.plan?.description?.toLowerCase().includes('platinum')">
                <ChatIcon 
                class="topbar-item mr-4" 
                style="cursor: pointer;" 
                svg-color="secondary"
                svg-title="OrderCircle Chats" 
                :unread-count="totalUnreadCount"
                @click.native="toggleDrawer"
                />

                <Drawer :is-drawer-active="isDrawerActive" :drawer-title="`OrderCircle Chats`"
                @hideDrawerToggle="hideDrawer">
                <template #drawerContent>
                    <div class="card-body p-0">
                    <chat />
                    </div>
                </template>
                <template #drawerOverlay>
                    <ChatBox style="margin-right: 500px;" v-for="(user, index) in openChats" :key="index" :index="index" :user="user" :position="index" />
                </template>
                </Drawer>
            </template>
               <div class="dropdown" v-if="disableCart">
                  <div class="topbar-item mr-3" data-toggle="dropdown" data-offset="0px,10px">
                     <a href="#"  class="btn label-danger  btn-light-danger mr-2">
                        <i class="fas fa-shopping-cart"></i>
                     </a>
                     <span class="label label-md label-danger mr-2 cartLabel">{{formattedCartProductCount}}</span>
                  </div>
                  <cartComponent @productCount="productCountMethod"></cartComponent>
               </div>
               <div class="dropdown">

               </div>
               <!--end: Cart-->
               <!--begin: User bar -->
               <AccountDetails v-on:brandLogoCatcher="updateBrandLogo($event)"></AccountDetails>

               <!--end: User bar -->
            </div>
         </div>
         <!-- end:: Brand -->
         <!-- begin:: Header Topbar -->
         <!-- end:: Header Topbar -->
        </div>
        <div v-if="$store.state.is_customer !== true">
           <div class="alert alert-success alertbanner" role="alert">
               {{ $t('shop_alert_text') }}
           </div>
        </div>
        <template v-if="$store.state.brand.shopBanner && $store.state.brand.shopBanner !== '0'">
           <div class="alert bg-light-primary promotionbanner" role="alert">
            <div v-html="$store.state.brand.shopBanner"></div>
           </div>
        </template>
        <div v-if="cant_create_order" class="card-container alertContainer">
            <div class="d-flex align-items-baseline flex-wrap">
               <div class="alert alert-custom alert-outline-2x alert-outline-warning fade show mt-3" role="alert">
                  <div class="alert-icon"><i class="flaticon-warning"></i></div>
                  <div class="alert-text">
                     We are temporarily not accepting online wholesale orders. Our online system will be back online shortly.
                  </div>
               </div>
            </div>
         </div>
        <div class="header-menu-wrapper header-menu-wrapper-left mt-10" id="kt_header_menu_wrapper">
            <div class="container-fluid">
         <!-- begin: Header Menu -->
                <div id="kt_header_menu" class="header-menu header-menu-left header-menu-mobile header-menu-layout-default header-menu-root-arrow" :style="dynamicStyle">
                    <ul class="menu-nav">
                       <li  class="menu-item menu-itsem-submenu menu-item-rel"  :class="{'menu-item-here':shopBool}" data-menu-toggle="click" aria-haspopup="true">
                          <router-link class="menu-link menu-toggle" to="/shop" role="button"><span class="menu-text">{{ $t('shop') }}</span></router-link>
                       </li>
                       <li class="menu-item menu-itsem-submenu menu-item-rel" :class="{'menu-item-here':ordersBool}" data-menu-toggle="hover" aria-haspopup="true">
                          <router-link class="menu-link menu-toggle" to="" role="button"><span class="menu-text">{{ $t('orders') }}</span><span class="menu-desc"></span><i class="fas fa-angle-down  pt-6 px-2 font-size-sm text-white"></i></router-link>
                          <div class="menu-submenu menu-submenu-classic menu-submenu-left" data-hor-direction="menu-submenu-left">
                             <ul class="menu-subnav">
                                <li class="menu-item" data-menu-toggle="hover" aria-haspopup="true">
                                   <router-link to="/shop/orders" class="menu-link menu-toggle"><i class="menu-icon fas fa-list"></i><span class="menu-text">{{ $t('orders_list') }}</span></router-link>
                                </li>
                                <li class="menu-item" data-menu-toggle="hover" aria-haspopup="true">
                                   <router-link to="/shop/orders/create" class="menu-link menu-toggle"><i class="menu-icon la la-plus"></i><span class="menu-text">{{ $t('add_new_order') }}</span></router-link>
                                </li>
                             </ul>
                          </div>
                       </li>
                       <li class="menu-item menu-item-submenu menu-item-rel"  :class="{'menu-item-here':settingBool}" data-menu-toggle="hover" aria-haspopup="true">
                          <!--router-link class="menu-link menu-toggle" to="" role="button"><span class="menu-text">Settings</span><i class="fas fa-angle-down  pt-6 px-2 font-size-sm"></i></router-link-->
                          <router-link href="javascript:void(0)" class="menu-link menu-toggle" to="" role="button"><span class="menu-text">{{ $t('settings') }}</span><i class="fas fa-angle-down  pt-6 px-2 font-size-sm text-white"></i></router-link>
                          <div class="menu-submenu menu-submenu-classic menu-submenu-left" data-hor-direction="menu-submenu-left">
                             <ul class="menu-subnav">
                                <li class="menu-item" data-menu-toggle="hover" aria-haspopup="true">
                                   <router-link to="/shop/setting/account" class="menu-link menu-toggle"><i class="menu-icon fas fa-cog"></i><span class="menu-text">{{ $t('settings') }}</span><span class="menu-desc"></span></router-link>
                                </li>
                                <li class="menu-item menu-item-submenu menu-item-rel" :class="{'menu-item-here':brandInfoBool}" data-menu-toggle="hover" aria-haspopup="true">
                                  <router-link class="menu-link menu-toggle" to="/shop/brand-info" role="button"><i class="menu-icon fas fa-info-circle"></i><span class="menu-text">{{ $t('brand_info') }}</span></router-link>
                               </li>
                                <li class="menu-item" data-menu-toggle="hover" aria-haspopup="true" v-if="paymentMethodConnected && allowCustomerCardPayment == 1">
                                   <router-link to="/shop/payment-info" class="menu-link menu-toggle"><i class="menu-icon fa fa-credit-card"></i><span class="menu-text">{{ $t('payment_info') }}</span></router-link>
                                </li>
                             </ul>
                          </div>
                       </li>
                       <li class="menu-item menu-item-submenu menu-item-rel" :class="{'menu-item-here':documentsBool}" data-menu-toggle="hover" aria-haspopup="true">
                          <router-link to="/shop/documents" class="menu-link menu-toggle" ><span class="menu-text">{{ $t('documents') }}</span></router-link>
                       </li>
                       <li v-if="this.$store.getters.brand['subdomain'] == 'nursewellness'" class="menu-item menu-item-submenu menu-item-rel" :class="{'menu-item-here':contactBool}" data-menu-toggle="hover" aria-haspopup="true">
                          <router-link to="/shop/contact" class="menu-link menu-toggle" ><span class="menu-text">{{ $t('Contact Us') }}</span></router-link>
                       </li>
                    </ul>
                </div>
                <div class="mt-5 customer-preview-link" v-if="$store.state.is_customer !== true" >
                    <a href="javascript:;" class="menu-link float-right pt-1 customer-preview-text" @click="endShopView();endCustomerPreviewClicked = true"><span class="w-80px font-weight-bolder" style="color:#e76450">{{ $t('end_customer_preview') }}</span></a>
                    <i class="fa fa-eye mr-2 pt-1 float-right mt-1 customer-preview-icon" style="color:#e76450"></i>
                   <!-- <button 
                        class="btn btn-outline-danger btn-md float-right py-3" 
                        @click="endShopView();endCustomerPreviewClicked = true;"
                        style="border-radius: 9px; padding: 8px 16px; font-weight: 600; transition: all 0.3s ease;
                        background-color: #dc3545; color: #fff; border: 2px solid #fff;"
                        @mouseout="$event.currentTarget.style.backgroundColor='#dc3545'; $event.currentTarget.style.color='white'; $event.currentTarget.querySelector('i').style.color='white'"
                        @mouseover="$event.currentTarget.style.backgroundColor='#d11717'; $event.currentTarget.style.color='white'; $event.currentTarget.querySelector('i').style.color='white'"
                        >
                        <i class="fa fa-eye mr-1" style="color: #fff"></i>
                        {{ $t('end_customer_preview') }}
                   </button> -->
                 </div>
         <!-- end: Header Menu -->
            </div>
        </div>
   </div>
</template>
<script>
import notificationsComponent from '@/js/ordercircle/brands/notifications/notification-list.vue';
import cartComponent from '@/js/ordercircle/brands/customers/Cart.vue';
import AccountDetails from '@/js/ordercircle/brands/layouts/accountdetails.vue';
import shop from '@/js/ordercircle/brands/store/shop.vue';
import BrandsAPIService from "@/js/api/main/brands";
import ShopAPIService from '@/js/api/store/shop';
import LoginAPIService from '@/js/api/auth/auth';
import ChatIcon from '@/js/svgs/chat-icon.vue';
import Drawer from '@/js/theme/components/drawer.vue';
import chat from '@/js/theme/components/chats/index.vue';
import ChatBox from '@/js/theme/components/chats/box.vue';
import { getUnreadMessagesCount, setUserAvailability, setupUserPresence } from '@/js/utils/firebase';
import { getBrandImageUrl } from '@/js/utils/common.js';

export default {
    name: 'topbar',
    components: {
        notificationsComponent,
        cartComponent,
        AccountDetails,
        shop,
        ChatIcon,
        Drawer,
        chat,
        ChatBox
      },
    data(){
        return{
            disableCart: true,
            shopBool:false,
            ordersBool:false,
            settingBool:false,
            documentsBool:false,
            brandInfoBool:false,
            contactBool:false,
            cartProductCount:0,
            brand_logo:null,
            paymentMethodConnected: false,
            endCustomerPreviewClicked: false,
            cant_create_order:false,
            pageURL:'',
            allowCustomerCardPayment: 1,
            isStripeConnected: false,
            isDrawerActive: false,
            totalUnreadCount: 0,
            openChats: [],
            stopChatPresenceListener: () => {},
            APIURL: import.meta.env.VITE_API_URL,
        }
    },
    methods:
    {
        getBrandImageUrl,
        async logout(e)
        {
            e.preventDefault();
            try {
                await this.setSessionPresenceOffline();
            } catch (error) {
                // Do not prevent logout if Firebase presence cannot be updated.
            }
            window.localStorage.removeItem('access_token');
            this.$store.commit('SET_SHOP_CUSTOMER_ID','');
            this.$router.push('/logout');
        },
        productCountMethod:function(value){
          this.cartProductCount = value;
        },
        updateBrandLogo : function (updatedLogo){
            this.brand_logo = updatedLogo;
            if(this.brand_logo != null &&  this.brand_logo != undefined &&  this.brand_logo != ""){
               this.brand_logo = '/uploads/brand_logos/'+ this.brand_logo;
            }else {
               this.brand_logo = '/images/brand_logos/dummy_company_logo.jpg';
            }
        },
        checkForConnectedPaymentMethods: function(){
           BrandsAPIService.getBrandConnectedPaymentMethods(this.access_token).then((response) => {
              if( response.data.isPayflowConnected == true || response.data.isAuthorizeConnected == true
                || response.data.isPaylianceConnected == true || response.data.isStripeConnected ==  true || response.data.isSquareConnected)
              {
                this.paymentMethodConnected = true;
                this.isStripeConnected = response.data.isStripeConnected;
              }
          });
        },
        checkCustomerCanCreateOrder(){
        ShopAPIService.getCustomerCanCreateOrder(this.$store.state.shopCustomerId, this.access_token).then((response) => {
            this.cant_create_order = response.data.customerCantCreateOrder;
             /**
             * The following chunk of code is added to allow the customer to add card details only if he is allowed by the admin,
             * because jack lee asked for it in order to restrict bigger customer from adding card details 
             * so that he could save the stripe fee and direct th customer to pay via bank transfer
             */
             this.allowCustomerCardPayment = response.data.allowCardPayment;
            this.allowCustomerCardPayment = this.isStripeConnected ? 1 : this.allowCustomerCardPayment;
          });
        },
        setNavigation(){
           this.pageURL=window.location.pathname;
           if(this.pageURL== '/shop'){
                this.shopBool = true;
                this.ordersBool = this.settingBool = this.documentsBool = this.contactBool = this.brandInfoBool = false;
            }else if(this.pageURL== '/shop/orders' || this.pageURL== '/shop/orders/create' || this.pageURL.includes('/shop/orders/')){
                 this.ordersBool = true;
                 this.shopBool = this.settingBool = this.documentsBool = this.contactBool = this.brandInfoBool = false;
            }
            else if(this.pageURL== '/shop/setting/account' || this.pageURL== '/shop/payment-info' || this.pageURL== '/shop/brand-info'){
                 this.settingBool = true;
                 this.shopBool = this.ordersBool = this.documentsBool = this.contactBool = this.brandInfoBool = false;
            }
            else if(this.pageURL== '/shop/documents'){
                 this.documentsBool = true;
                 this.shopBool = this.ordersBool = this.settingBool = this.contactBool = this.brandInfoBool = false;
            }
            else if(this.pageURL== '/shop/contact'){
                 this.contactBool = true;
                 this.shopBool = this.ordersBool = this.settingBool = this.brandInfoBool = this.documentsBool = false;
            }
        },
        endShopView(){
         this.$store.commit('SHOW_LOADER',true);
         localStorage.removeItem('impersonated');
         LoginAPIService.backToBrandDashboard({
            username : this.$store.state.remember_role
         }).then((response) => {
            this.$store.commit('SHOW_LOADER',false);
            this.$store.dispatch('getData',response.data)
            this.$store.commit('SET_SHOP_CUSTOMER_ID','');
            // this.$router.push("/dashboard");
            window.location.href='/dashboard'
        }).catch((error) => {
            this.$store.commit('SHOW_LOADER',false);
            this.notify("Error!", "Error", "error");
        })
        },
        getChatPresenceContext() {
            const type = this.$store.getters.role.split('-')[0];
            const id = this.$store.getters.user.user.role?.id;
            const mappedType = type === 'staff' ? 'staffs' : type === 'customer' ? 'customers' : type;

            return {
                user: { type: mappedType, id },
                brandId: this.$store.getters.brand?.id,
            };
        },
        setSessionPresenceActive() {
            const { user, brandId } = this.getChatPresenceContext();
            this.stopChatPresenceListener();
            this.stopChatPresenceListener = setupUserPresence(user, brandId, 'active');
        },
        setSessionPresenceOffline() {
            const { user, brandId } = this.getChatPresenceContext();
            this.stopChatPresenceListener();
            this.stopChatPresenceListener = () => {};
            return setUserAvailability(user, brandId, 'offline');
        },
        toggleDrawer() {
            this.isDrawerActive = !this.isDrawerActive;
        },
        hideDrawer() {
            this.isDrawerActive = false;
        }
    },
    mounted(){
        // A customer is active for their whole signed-in shop session, whether
        // or not they have opened the chat drawer.
        this.setSessionPresenceActive();
        this.setNavigation()
        this.checkCustomerCanCreateOrder();
        this.$root.eventBus.on('disableCart', () => {
            this.disableCart = true;
        })
        if(this.$route.name == 'customer-create-order' || this.$route.name == 'reorder-customer'){
            this.disableCart = false;
        }
        this.brand_logo = '/images/brand_logos/dummy_company_logo.jpg';
        this.checkForConnectedPaymentMethods();
        const type1 = this.$store.getters.role;
        const type=type1.split('-')[0];
        const id = this.$store.getters.user.user.role?.id;
        const mappedType = type === 'staff' ? 'staffs' : type === 'customer' ? 'customers' : type;
        const userKey = `${mappedType}-${id}`;
        const brandId = this.$store.getters.brand?.id;
        getUnreadMessagesCount(brandId, userKey, (count) => {
        this.totalUnreadCount = count;
        });

        // this.openChats = this.$store.getters['openChats'];
    },
    beforeUnmount() {
        this.setSessionPresenceOffline();
    },
    watch: {
        '$route' (to, from) {
            if(to.name == 'customer-create-order' || to.name == 'reorder-customer'){
               this.disableCart = false;
            }else{
                this.disableCart = true;
            }
            this.setNavigation()
        }
    },
    beforeRouteUpdate(to, from, next) {
        next();
    },
    computed:{
        topbarColor(){
            return {
                'background-color': this.$store.state.brand_skins['shop_topbar_bg_color'],
            };
        },
        dynamicStyle() {
            return {
                '--topbar-color': this.$store.state.brand_skins['shop_menubar_bg_color'] || '#404547',
            };
        },
        showEndCustomerShopPreview() {
            return window.App.isImpersonated;
        },
        openChats() {
            return this.$store.getters['openChats']; // make it reactive!
        },
        shouldShowChatIcon() {
            return localStorage.getItem('impersonated') !== 'true';
        },
        formattedCartProductCount() {
            // Check if the value is a float (has decimal places)
            if (this.cartProductCount % 1 !== 0) {
                return parseFloat(this.cartProductCount).toFixed(2);
            }
            return this.cartProductCount;
        }
    },
};
</script>
<style scoped>
.topbar-item{
	display: flex;
	align-items: center;
}
 .cartLabel{
     vertical-align: top;
     margin-left: -18px;
     margin-top: -26px;
     font-size: 9.5px;
     height:23px !important;
     width:23px !important;
}
 .alertbanner{
     display: inline-block;
     border-radius: 4px;
     margin: 15px 100px;
     background-color: #E7F6F4;
     color:black;
}
.promotionbanner{
     border-radius: 4px;
     margin: 15px 100px;
     text-align: center;
}
 .alertContainer{
     width: 100%;
     margin-bottom: -1.5rem;
     margin-top: 1.5rem;
}
 .alert-custom{
     margin-left: 100px;
     padding: 1px 20px 1px 20px;
}
 @media(min-width: 992px){
     .header-menu .menu-nav > .menu-item > .menu-link .menu-text{
         color: #e5eaee !important;
         text-transform:uppercase !important;
         font-weight: 600 !important;
         font-size: 1rem !important;
    }
     .header-menu .menu-nav > .menu-item > .menu-link{
         padding: 0 1.75rem !important;
    }
     .header-menu .menu-nav > .menu-item{
         padding: 0px !important;
         align-items: stretch !important;
    }
}
 @media(max-width: 992px){
   #kt_header_menu_wrapper > .container-fluid {
     padding-right: 0 !important;
     padding-left: 0 !important;
   }
   #kt_header_menu .menu-nav {
     width: 100%;
     margin: 0 !important;
     padding: 0 !important;
   }
   #kt_header_menu .menu-nav > .menu-item {
     width: 100%;
     margin: 0 !important;
   }
   #kt_header_menu .menu-nav > .menu-item > .menu-link {
     width: 100%;
     padding-right: 3rem !important;
     padding-left: 3rem !important;
   }
   .customer-preview-link {
     display: flex;
     align-items: center;
     justify-content: flex-start;
     width: 100%;
     padding-left: 3rem;
   }
   .customer-preview-text,
   .customer-preview-icon {
     float: none !important;
   }
   .customer-preview-icon {
     order: 1;
     margin-top: 0 !important;
   }
   .customer-preview-text {
     order: 2;
     width: auto;
   }
   .customer-preview-text > span {
     width: auto !important;
     white-space: nowrap;
   }
   .cartLabel{
     vertical-align: top;
     margin-left: -18px;
     margin-top: -4px !important;
     font-size: 9.5px;
     height:23px !important;
     width:23px !important;
}
   .alertContainer{
         margin-bottom: -0.5rem !important;
    }
     .alert-custom{
         margin-left: 30px;
         margin-right:30px;
    }
     .alertbanner{
         margin: 16px;
    }
}
 li{
     border-top-left-radius: 7px !important;
     border-top-right-radius: 7px !important;
}
 @media (min-width: 1400px){
     .container, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
         max-width: 3000px !important;
    }
}
 @media (min-width: 992px){
     .container{
         padding: 0px !important;
    }
     .header-menu .menu-nav > .menu-item{
         background-color: #393c40;
         border-radius: 3px;
    }
     .header .container, .header .container-fluid, .header .container-sm, .header .container-md, .header .container-lg, .header .container-xl, .header .container-xxl{
         justify-content: space-between !important;
         display: -webkit-box;
         display: -ms-flexbox;
         display: flex;
         -webkit-box-align: stretch;
         -ms-flex-align: stretch;
         align-items: stretch;
         -webkit-box-pack: justify;
    }
     .header{
         height: 60px !important;
    }
}
 @media (max-width: 600px){
     .promotionbanner {
         margin: 16px;
         overflow: hidden;
     }
     .promotionbanner :deep(img) {
         max-width: 60% !important;
         height: auto !important;
     }
     #kt_header_mobile > a > img {
         width: 150px !important;
         height: auto !important;
     }
     .orderlistDropdown {
         width:100% !important;
         padding: 0px !important;
    }
     .accountDetailDropdownMenu{
         width: 75vw !important;
    }
     .orderlistButton{
         width:100%;
         margin:0.25rem !important;
    }
     .viewOrderDropdown {
         width:100% !important;
         padding: 0px !important;
    }
     .viewOrderButton{
         width:100%;
         margin:0.25rem !important;
    }
     .create-order-banner{
         display: none !important;
    }
     .all-order-statuses-button{
         float: none !important;
         -webkit-box-pack: center !important;
         justify-content: center !important;
    }
     .mobileCustom{
         width:100% !important;
    }
     .orderInvoiceLabels{
         width:50% !important;
    }
}
 @media (min-width: 992px) {
     .d-lg-none {
         display: none !important;
    }
     .d-lg-inline {
         display: inline !important;
    }
     .d-lg-inline-block {
         display: inline-block !important;
    }
     .d-lg-block {
         display: block !important;
    }
     .d-lg-table {
         display: table !important;
    }
     .d-lg-table-row {
         display: table-row !important;
    }
     .d-lg-table-cell {
         display: table-cell !important;
    }
     .d-lg-flex {
         display: -webkit-box !important;
         display: -ms-flexbox !important;
         display: flex !important;
    }
     .d-lg-inline-flex {
         display: -webkit-inline-box !important;
         display: -ms-inline-flexbox !important;
         display: inline-flex !important;
    }
}
 @media (min-width: 1200px) {
     .d-xl-none {
         display: none !important;
    }
     .d-xl-inline {
         display: inline !important;
    }
     .d-xl-inline-block {
         display: inline-block !important;
    }
     .d-xl-block {
         display: block !important;
    }
     .d-xl-table {
         display: table !important;
    }
     .d-xl-table-row {
         display: table-row !important;
    }
     .d-xl-table-cell {
         display: table-cell !important;
    }
     .d-xl-flex {
         display: -webkit-box !important;
         display: -ms-flexbox !important;
         display: flex !important;
    }
     .d-xl-inline-flex {
         display: -webkit-inline-box !important;
         display: -ms-inline-flexbox !important;
         display: inline-flex !important;
    }
}
 @media (min-width: 1400px) {
     .d-xxl-none {
         display: none !important;
    }
     .d-xxl-inline {
         display: inline !important;
    }
     .d-xxl-inline-block {
         display: inline-block !important;
    }
     .d-xxl-block {
         display: block !important;
    }
     .d-xxl-table {
         display: table !important;
    }
     .d-xxl-table-row {
         display: table-row !important;
    }
     .d-xxl-table-cell {
         display: table-cell !important;
    }
     .d-xxl-flex {
         display: -webkit-box !important;
         display: -ms-flexbox !important;
         display: flex !important;
    }
     .d-xxl-inline-flex {
         display: -webkit-inline-box !important;
         display: -ms-inline-flexbox !important;
         display: inline-flex !important;
    }
}
 @media (max-width: 991.98px) {
     .header-menu-wrapper {
         z-index: 1001;
         position: fixed;
         top: 0;
         bottom: 0;
         -webkit-transition: left 0.3s ease, right 0.3s ease, bottom 0.3s ease, top 0.3s ease;
         transition: left 0.3s ease, right 0.3s ease, bottom 0.3s ease, top 0.3s ease;
         left: -295px;
         width: 275px;
    }
     .header-menu-wrapper.header-menu-wrapper-on {
         -webkit-transition: left 0.3s ease, right 0.3s ease, bottom 0.3s ease, top 0.3s ease;
         transition: left 0.3s ease, right 0.3s ease, bottom 0.3s ease, top 0.3s ease;
         left: 0;
    }
}
 @media screen and (max-width: 991.98px) and (-ms-high-contrast: active), (max-width: 991.98px) and (-ms-high-contrast: none) {
     .header-menu-wrapper {
         -webkit-transition: none !important;
         transition: none !important;
    }
}
 @media (max-width: 991.98px) {
     .header-menu-wrapper.header-menu-wrapper-right {
         right: -295px;
         left: auto;
    }
     .header-menu-wrapper.header-menu-wrapper-right.header-menu-wrapper-on {
         -webkit-transition: left 0.3s ease, right 0.3s ease, bottom 0.3s ease, top 0.3s ease;
         transition: left 0.3s ease, right 0.3s ease, bottom 0.3s ease, top 0.3s ease;
         right: 0;
         left: auto;
    }
     .header-menu-wrapper-overlay {
         position: fixed;
         top: 0;
         left: 0;
         bottom: 0;
         right: 0;
         overflow: hidden;
         z-index: 1000;
         -webkit-animation: animation-offcanvas-fade-in .6s ease 1;
         animation: animation-offcanvas-fade-in .6s ease 1;
    }
     @-webkit-keyframes animation-offcanvas-fade-in {
         from {
             opacity: 0;
        }
         to {
             opacity: 1;
        }
    }
     @keyframes animation-offcanvas-fade-in {
         from {
             opacity: 0;
        }
         to {
             opacity: 1;
        }
    }
     .header-menu-wrapper {
         background: #ffffff;
         -webkit-box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.75);
         box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.75);
    }
     .header-menu-wrapper-overlay {
         background: rgba(0, 0, 0, 0.1);
    }
}
 @media (max-width: 325px) {
     .header-menu-wrapper {
         width: 90% !important;
    }
}
 @media (min-width: 992px) {
     .header-menu-wrapper {
         display: -webkit-box;
         display: -ms-flexbox;
         display: flex;
         -webkit-box-align: stretch;
         -ms-flex-align: stretch;
         align-items: stretch;
         height: 50px;
         position: relative;
    }
     .header-menu-wrapper .container, .header-menu-wrapper .container-fluid, .header-menu-wrapper .container-sm, .header-menu-wrapper .container-md, .header-menu-wrapper .container-lg, .header-menu-wrapper .container-xl, .header-menu-wrapper .container-xxl {
         display: -webkit-box;
         display: -ms-flexbox;
         display: flex;
         -webkit-box-align: stretch;
         -ms-flex-align: stretch;
         align-items: stretch;
         -webkit-box-pack: justify;
         -ms-flex-pack: justify;
         justify-content: space-between;
    }
     .header-menu {
         display: -webkit-box;
         display: -ms-flexbox;
         display: flex;
         -webkit-box-align: stretch;
         -ms-flex-align: stretch;
         align-items: stretch;
    }
     .header-menu .menu-nav {
         display: -webkit-box;
         display: -ms-flexbox;
         display: flex;
         -webkit-box-align: stretch;
         -ms-flex-align: stretch;
         align-items: stretch;
    }
     .header-menu .menu-nav > .menu-item {
         display: -webkit-box;
         display: -ms-flexbox;
         display: flex;
         -webkit-box-align: stretch;
         -ms-flex-align: stretch;
         align-items: stretch;
         padding: 0;
         margin-right: 0.35rem;
    }
     .header-menu .menu-nav > .menu-item:first-child {
         padding-left: 0;
    }
     .header-menu .menu-nav > .menu-item > .menu-link {
         display: -webkit-box;
         display: -ms-flexbox;
         display: flex;
         -webkit-box-align: stretch;
         -ms-flex-align: stretch;
         align-items: stretch;
         padding: 0 1.75rem;
         border-top-left-radius: 0.42rem;
         border-top-right-radius: 0.42rem;
         background-color: rgba(255, 255, 255, 0.1);
    }
     .header-menu .menu-nav > .menu-item > .menu-link .menu-text {
         color: #e5eaee;
         font-weight: 600;
         font-size: 1rem;
         text-transform: uppercase;
    }
     .header-menu .menu-nav > .menu-item > .menu-link .menu-arrow {
         color: #e5eaee;
    }
     .header-menu .menu-nav > .menu-item > .menu-link .menu-icon i {
         color: #e5eaee;
    }
     .header-menu .menu-nav > .menu-item > .menu-link .menu-icon .svg-icon svg g [fill] {
         -webkit-transition: fill 0.3s ease;
         transition: fill 0.3s ease;
         fill: #e5eaee;
    }
     .header-menu .menu-nav > .menu-item > .menu-link .menu-icon .svg-icon svg:hover g [fill] {
         -webkit-transition: fill 0.3s ease;
         transition: fill 0.3s ease;
    }
     .header-menu .menu-nav > .menu-item:hover:not(.menu-item-here):not(.menu-item-active) > .menu-link, .header-menu .menu-nav > .menu-item.menu-item-hover:not(.menu-item-here):not(.menu-item-active) > .menu-link {
         background-color: rgba(255, 255, 255, 0.2);
    }
     .header-menu .menu-nav > .menu-item:hover:not(.menu-item-here):not(.menu-item-active) > .menu-link .menu-text, .header-menu .menu-nav > .menu-item.menu-item-hover:not(.menu-item-here):not(.menu-item-active) > .menu-link .menu-text {
         color: #ffffff;
    }
     .header-menu .menu-nav > .menu-item:hover:not(.menu-item-here):not(.menu-item-active) > .menu-link .menu-arrow, .header-menu .menu-nav > .menu-item.menu-item-hover:not(.menu-item-here):not(.menu-item-active) > .menu-link .menu-arrow {
         color: #ffffff;
    }
     .header-menu .menu-nav > .menu-item:hover:not(.menu-item-here):not(.menu-item-active) > .menu-link .menu-icon i, .header-menu .menu-nav > .menu-item.menu-item-hover:not(.menu-item-here):not(.menu-item-active) > .menu-link .menu-icon i {
         color: #ffffff;
    }
     .header-menu .menu-nav > .menu-item:hover:not(.menu-item-here):not(.menu-item-active) > .menu-link .menu-icon .svg-icon svg g [fill], .header-menu .menu-nav > .menu-item.menu-item-hover:not(.menu-item-here):not(.menu-item-active) > .menu-link .menu-icon .svg-icon svg g [fill] {
         -webkit-transition: fill 0.3s ease;
         transition: fill 0.3s ease;
         fill: #ffffff;
    }
     .header-menu .menu-nav > .menu-item:hover:not(.menu-item-here):not(.menu-item-active) > .menu-link .menu-icon .svg-icon svg:hover g [fill], .header-menu .menu-nav > .menu-item.menu-item-hover:not(.menu-item-here):not(.menu-item-active) > .menu-link .menu-icon .svg-icon svg:hover g [fill] {
         -webkit-transition: fill 0.3s ease;
         transition: fill 0.3s ease;
    }
     .header-menu .menu-nav > .menu-item.menu-item-here > .menu-link, .header-menu .menu-nav > .menu-item.menu-item-active > .menu-link {
         background-color: #f9f9fc;
    }
     .header-menu .menu-nav > .menu-item.menu-item-here > .menu-link .menu-text, .header-menu .menu-nav > .menu-item.menu-item-active > .menu-link .menu-text {
         color: #212121;
    }
     .header-menu .menu-nav > .menu-item.menu-item-here > .menu-link .menu-arrow, .header-menu .menu-nav > .menu-item.menu-item-active > .menu-link .menu-arrow {
         color: #212121;
    }
     .header-menu .menu-nav > .menu-item.menu-item-here > .menu-link .menu-icon i, .header-menu .menu-nav > .menu-item.menu-item-active > .menu-link .menu-icon i {
         color: #212121;
    }
     .header-menu .menu-nav > .menu-item.menu-item-here > .menu-link .menu-icon .svg-icon svg g [fill], .header-menu .menu-nav > .menu-item.menu-item-active > .menu-link .menu-icon .svg-icon svg g [fill] {
         -webkit-transition: fill 0.3s ease;
         transition: fill 0.3s ease;
         fill: #212121;
    }
     .header-menu .menu-nav > .menu-item.menu-item-here > .menu-link .menu-icon .svg-icon svg:hover g [fill], .header-menu .menu-nav > .menu-item.menu-item-active > .menu-link .menu-icon .svg-icon svg:hover g [fill] {
         -webkit-transition: fill 0.3s ease;
         transition: fill 0.3s ease;
    }
}
 @media (max-width: 991.98px) {
     .header-menu-wrapper {
         overflow: auto;
    }
     .header-menu-wrapper .container {
         padding: 0;
    }
}
 body{
     background-color: #f2f3f8;
}
 .btn.btn-success{
     background-color: #1bac94 !important;
}
 @media (min-width: 1400px){
     .container, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
         max-width: 3000px !important;
    }
}
 @media (min-width: 992px){
     .container{
         padding: 0px !important;
    }
     .header-menu .menu-nav > .menu-item{
         /* background-color: #393c40; */
         background-color: var(--topbar-color) !important;
         border-radius: 3px;
    }
     .header .container, .header .container-fluid, .header .container-sm, .header .container-md, .header .container-lg, .header .container-xl, .header .container-xxl{
         justify-content: space-between !important;
    }
     .header{
         height: 60px !important;
    }
}
 .form-control{
    /* border-radius:0px !important;
     */
}
 .header-menu .menu-nav > .menu-item.menu-item-here > .menu-link, .header-menu .menu-nav > .menu-item.menu-item-active > .menu-link {
     background-color: #479fd7 !important;
     /* background-color: var(--topbar-color) !important; */
}
 .text-blue{
     color: #479fd7;
}
 .text-green{
     background-color: #E7F6F4 !important;
     opacity: 0.9;
}
 .bg-green{
     background-color: #E7F6F4;
     opacity: 0.9;
}
 .custom-card{
     background-color: #ffffff;
     border: 0.1px solid #9285851f !important;
     box-shadow: 5px 3px 3px 2px #b7b5b51c;
}
 .custom-card > .card-header{
     display: -webkit-box;
     display: -ms-flexbox;
     display: flex;
     -webkit-box-pack: justify;
     -ms-flex-pack: justify;
     justify-content: space-between;
     -webkit-box-align: stretch;
     -ms-flex-align: stretch;
     align-items: stretch;
     -ms-flex-wrap: wrap;
     flex-wrap: wrap;
     min-height: 70px;
     padding-top: 0;
     padding-bottom: 0;
     background-color: transparent;
}
 .custom-card > .card-header .card-title {
     display: -webkit-box;
     display: -ms-flexbox;
     display: flex;
     -webkit-box-align: center;
     -ms-flex-align: center;
     align-items: center;
     margin: 0.5rem;
     margin-left: 0;
}
 .custom-card > .card-header .card-toolbar {
     display: -webkit-box;
     display: -ms-flexbox;
     display: flex;
     -webkit-box-align: center;
     -ms-flex-align: center;
     align-items: center;
     margin: 0.5rem 0;
     -ms-flex-wrap: wrap;
     flex-wrap: wrap;
}
 .header-menu .menu-nav > .menu-item.menu-item-here > .menu-link .menu-text, .header-menu .menu-nav > .menu-item.menu-item-active > .menu-link .menu-text{
     color:#ffffff;
}
 .cart-scrollable{
     overflow-y: auto;
     max-height: 232px;
     min-height: 232px;
}
 .btn.btn-primary{
     background-color: #007bff;
     border-color:#007bff;
}
 .cardHeaderBorder{
     border-bottom: 1px solid #cdc5c5 !important;
}
 .btn.btn-light-primary{
     background-color: #5caae2;
     color:#ffffff;
     border-color:transparent;
}
 .btn.btn-light-primary i,.btn.btn-light-primary .btn-text {
     color: #ffffff;
}
/* .nav.nav-tabs.nav-tabs-line.nav-tabs-line-2x .nav-link:hover:not(.disabled), .nav.nav-tabs.nav-tabs-line.nav-tabs-line-2x .nav-link.active, .nav.nav-tabs.nav-tabs-line.nav-tabs-line-2x .show > .nav-link{
     border-bottom: 3px solid #479fd7;
}
 */
 .nav.nav-tabs.nav-tabs-line .nav-link:hover:not(.disabled), .nav.nav-tabs.nav-tabs-line .nav-link.active, .nav.nav-tabs.nav-tabs-line .show > .nav-link{
     color: #000000;
}
/* a:hover{
     color: #479fd7 !important;
}
 */
 .btn.btn-primary:not(:disabled):not(.disabled):active:not(.btn-text), .btn.btn-primary:not(:disabled):not(.disabled).active, .show > .btn.btn-primary.dropdown-toggle, .show .btn.btn-primary.btn-dropdown{
     color: #FFFFFF;
     background-color: #007bff;
     border-color: #007bff;
}
 .btn.btn-primary:hover:not(.btn-text):not(:disabled):not(.disabled), .btn.btn-primary:focus:not(.btn-text), .btn.btn-primary.focus:not(.btn-text){
     color: #FFFFFF;
     background-color: #007bff;
     border-color: #007bff;
}
 span.select2.select2-container.select2-container--default.select2-container--below{
     width: 100% !important;
}
 span.select2.select2-container.select2-container--default{
     width: 100% !important;
}
 @media (max-width: 600px){
     .orderlistDropdown {
         width:100% !important;
         padding: 0px !important;
    }
     .accountDetailDropdownMenu{
         width: 75vw !important;
    }
     .orderlistButton{
         width:100%;
         margin:0.25rem !important;
    }
     .viewOrderDropdown {
         width:100% !important;
         padding: 0px !important;
    }
     .viewOrderButton{
         width:100%;
         margin:0.25rem !important;
    }
     .create-order-banner{
         display: none !important;
    }
     .all-order-statuses-button{
         float: none !important;
         -webkit-box-pack: center !important;
         justify-content: center !important;
    }
     .mobileCustom{
         width:100% !important;
    }
     .orderInvoiceLabels{
         width:50% !important;
    }
}
 @media (min-width: 992px) {
     body.header-fixed[data-header-scroll="on"] {
         padding-top: 100px;
    }
     .main {
         border-top-left-radius: 0;
    }
     .aside-enabled .main {
         border-bottom-left-radius: 0;
    }
     .container {
         padding: 0 25px;
    }
     .container-fluid, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
         padding: 0 100px;
    }
}
 @media (max-width: 991.98px) {
     .container, .container-fluid, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
         max-width: none;
         padding: 0 15px;
    }
}

</style>
